import { inject, type InjectionKey } from "vue";
import type ConfigurationFileContents from "@/interfaces/Configuration/ConfigurationFileContents";

export const runtimeConfigurationKey: InjectionKey<ConfigurationFileContents> =
  Symbol("runtimeConfiguration");

export function useRuntimeConfiguration() {
  const runtimeConfiguration = inject(runtimeConfigurationKey);

  if (!runtimeConfiguration) {
    throw new Error("Runtime configuration has not been provided.");
  }

  return runtimeConfiguration;
}
